<template>
  <v-dialog
      scrollable
      v-model="visable"
      max-width="600px"
      :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '正在提交…': '确认提交？' }}
      </v-card-title>

      <v-divider></v-divider>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
        <v-divider/>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                    label="校章用印数"
                    v-model="form.instSealNum"
                    :rules="rules.amount"
                />
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                    label="法人章用印数"
                    v-model="form.corpSealNum"
                    :rules="rules.amount"
                />
              </v-flex>

<!--              <v-flex xs12>-->
<!--                <v-textarea-->
<!--                    label="用印内容"-->
<!--                    v-model="form.sealContent"-->
<!--                    :rules="rules.normal"-->
<!--                />-->
<!--              </v-flex>-->
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="$emit('input', false)">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onSubmit">确认</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  model: {
    prop: 'visable',
    event: 'input'
  },

  props: ['visable', 'message', 'uri', 'dbid'],

  data() {
    return {
      formValid: false,
      loading: false,
      form: {
        corpSealNum: 0,
        instSealNum: 0,
        sealContent:""
      },
      rules: {
        normal: [
          v => !!v || '必填项。',
          v => (v && v.length <= 200) || '长度必须小于100个字符。'
        ],
        amount: [
          v => (!!v || v==='0') || '必填项。',
          v => (v && /^\d{1,10}$/ig.test(v)) || '填写整数。'
        ],

      }
    }
  },

  methods: {
    onSubmit() {
      const vm = this;
      if (this.$refs.formRef.validate()) {
        this.loading = true;
        const param = this.form;
        this.axios.put(`${this.uri}/seal/${this.dbid}`, param)
            .then(rsp => {
              vm.$emit('seal', rsp.data);
              vm.$emit('input', false);
              vm.loading = false;
            });
      }
    }
  }
}
</script>
<style scoped>

</style>
